// Firebase compat layer.
//
// Sostituisce gli script CDN (firebase 8.10.1) caricando l'SDK v12 via npm
// ma esponendo l'API v8 globale (`firebase.foo()`). Permette ai 53 file
// legacy che usano `firebase.firestore()`, `firebase.auth()`, ecc. di
// continuare a funzionare senza riscritture immediate.
//
// La migrazione progressiva alla API modulare (`import { getFirestore } from
// 'firebase/firestore'`) avviene in PR dedicate per dominio. Quando tutti i
// consumer saranno modulari, questo file e il `window.firebase` potranno
// essere rimossi.
//
// Le chiavi Firebase Web sono pubbliche per design — il vero controllo
// d'accesso è nelle Firestore Security Rules. Restano comunque candidate
// allo spostamento in `import.meta.env.VITE_FIREBASE_*` quando si farà
// l'audit env vars.

import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import 'firebase/compat/messaging';
import 'firebase/compat/analytics';
import 'firebase/compat/storage';

const firebaseConfig = {
  apiKey: 'AIzaSyAv673Z3d-_EeCiLCD7hp6sromZGD0HTjM',
  authDomain: 'mytransport-246817.firebaseapp.com',
  databaseURL: 'https://mytransport-246817.firebaseio.com',
  projectId: 'mytransport-246817',
  storageBucket: 'mytransport-246817.appspot.com',
  messagingSenderId: '820418200771',
  appId: '1:820418200771:web:0af97a62c41be739edce76',
  measurementId: 'G-R7YKW71LDT',
};

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
  firebase.analytics();
}

if (typeof window !== 'undefined') {
  window.firebase = firebase;
}

export default firebase;
